// 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
// Core owns the support receipt projection for every client.
import { buildSupportTicketTrackingMessage } from './global-assistant-message.utils';
function record(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown> : {};
}
function positiveId(value: unknown): string | null {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  if (typeof value === 'number' && !Number.isSafeInteger(value)) return null;
  const id = String(value);
  return /^[1-9][0-9]{0,18}$/.test(id) && BigInt(id) <= 9223372036854775807n ? id : null;
}
/** A provider success flag alone is not a persisted, purpose-scoped chat result. */
export function readAssistantSupportReceipt(
  result: unknown,
  expectedTarget: 'QUBEPRO_SAAS' | 'TENANT_INTERNAL',
  expectedConversationId?: number | string | null,
  language?: string,
): { conversationId: number | string; message: string; timestamp: string } | null {
  const data = record(result), receipt = record(data.actionReceipt);
  const message = record(receipt.message), proof = record(record(message.metadata).actionReceipt);
  const ticketId = positiveId(data.ticketId), conversationId = positiveId(receipt.conversationId);
  if ((data.created !== true && data.alreadyExists !== true) || !ticketId
    || typeof data.ticketNumber !== 'string' || !data.ticketNumber.trim() || data.ticketNumber.length > 120
    || data.supportTarget !== expectedTarget || receipt.purpose !== (expectedTarget === 'QUBEPRO_SAAS' ? 'QUBEPRO_HELP' : 'BUSINESS')
    || !conversationId
    || (expectedConversationId != null && String(expectedConversationId) !== conversationId)
    || typeof receipt.id !== 'string' || !/^[A-Za-z0-9-]{8,64}$/.test(receipt.id)
    || !positiveId(receipt.messageId) || message.role !== 'assistant'
    || typeof message.content !== 'string' || !message.content.trim() || message.content.length > 2000
    || typeof message.timestamp !== 'string' || !Number.isFinite(Date.parse(message.timestamp))
    || proof.version !== 1 || proof.id !== receipt.id || proof.type !== 'support'
    || proof.recordId !== ticketId || proof.ticketNumber !== data.ticketNumber
    || proof.supportTarget !== expectedTarget) return null;
  return {
    conversationId,
    message: buildSupportTicketTrackingMessage(message.content, {
      created: data.created === true,
      alreadyExists: data.alreadyExists === true,
      ticketNumber: proof.ticketNumber,
      supportTarget: proof.supportTarget,
    }, language),
    timestamp: message.timestamp,
  };
}
